import React from 'react'
import PropTypes from 'prop-types'
import componentObj from './dataset'

const Header = ({ selected, children }) => {
  const { title, description } = componentObj.find(({ value }) => value === selected)

  return (
    <div className="flex flex-col md:flex-row items-center justify-between mx-5">
      <div className="flex-1">
        <h1 className="text-3xl text-primary-black">{title}</h1>
        <p className="text-dim-gray max-w-4xl">{description}</p>
      </div>
      {children}
    </div>
  )
}

Header.propTypes = {
  selected: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default Header
